import { useState } from 'react';
import type { SemVehicleInventory } from '~/contracts/sem';
import {
  Tile,
  TileImageSection,
  TileInfoSection,
  Trim,
  TrimMileage,
  YearMakeModel
} from './VehicleTile.styles';

const VehicleTile = ({
  title,
  imageUrl,
  price,
  trim,
  mileage
}: SemVehicleInventory) => {
  const [imgError, setImgError] = useState(false);

  return (
    <Tile>
      <TileImageSection>
        {imageUrl && (
          <picture>
            <source srcSet={imageUrl} media="(min-width: 1440px)" />
            <img
              className="h-full w-full rounded-t-md object-cover"
              src={
                imgError
                  ? `${process.env.CVNA_APP_VEX_STOCK_CDN_URL}/generic_vehicle_desktop_1920x1080.png`
                  : imageUrl
              }
              alt={title ?? ''}
              onError={() => setImgError(true)}
            />
          </picture>
        )}
      </TileImageSection>
      <TileInfoSection>
        <YearMakeModel>{title}</YearMakeModel>
        <TrimMileage>
          <Trim>{trim} </Trim>
          <span className="mx-md inline-block h-4 w-4 rounded-full bg-text-default" />
          <span>{mileage}</span>
        </TrimMileage>
        <h3 className="t-strong-xl">{price}</h3>
      </TileInfoSection>
    </Tile>
  );
};

export default VehicleTile;
